// extracted by mini-css-extract-plugin
module.exports = {"SideMenu":"SideMenu_SideMenu__3XqYz"};